import { ActiveFiltersV2 } from 'contexts/v2/app-context';
import React, { useId } from 'react';

import { Separator } from 'components/ui/separator';

import { FilterDropdown } from './filter-dropdown/filter-dropdown';
import { FilterConfig } from './filter-dropdown/types';

interface FilterDropdownSectionProps {
  filterKey: string;
  filter: FilterConfig;
  activeFiltersV2: ActiveFiltersV2;
  getActiveFilterKey: (key: string) => keyof ActiveFiltersV2;
  setActiveFiltersV2: (
    prev: (prev: ActiveFiltersV2) => ActiveFiltersV2,
  ) => void;
  accountSlug: string | null;
  brandId: string;
  updateUrlWithParams: (
    accountSlug: string,
    brandId: string,
    key: string,
    value: string[],
  ) => void;
  setPage: (page: number) => void;
}

export function DropdownSection({
  filterKey,
  filter,
  activeFiltersV2,
  getActiveFilterKey,
  setActiveFiltersV2,
  accountSlug,
  brandId,
  updateUrlWithParams,
  setPage,
}: FilterDropdownSectionProps) {
  const labelId = useId();
  const activeKey = getActiveFilterKey(filterKey);
  const currentValue = activeFiltersV2[activeKey];
  const selectedValues = Array.isArray(currentValue) ? currentValue : [];

  return (
    <>
      <div className="bg-white px-4 py-3">
        <label
          id={labelId}
          className="mb-2 block text-sm font-medium text-gray-900"
        >
          {filter.label}
        </label>
        <FilterDropdown
          label={filter.label}
          labelledBy={labelId}
          selected={selectedValues}
          setSelected={newSelected => {
            setActiveFiltersV2((prev: ActiveFiltersV2) => ({
              ...prev,
              [activeKey]: newSelected,
            }));

            if (accountSlug) {
              const urlValue = newSelected.map(opt => opt.key);
              updateUrlWithParams(accountSlug, brandId, activeKey, urlValue);
              updateUrlWithParams(accountSlug, brandId, 'page', ['1']);
            }

            setPage(1);
          }}
          showLabel
          name={filterKey}
          placeholder={filter.placeholder ?? ''}
          searchPlaceholder={filter.searchPlaceholder ?? ''}
          options={filter.options}
        />
      </div>
      {filter.hasSeparator && (
        <div className="px-4">
          <Separator />
        </div>
      )}
    </>
  );
}
